<template>
    <div id="app">
        <!-- 路由容器 -->
        <router-view></router-view>
    </div>
</template>


<script>
    /**
     * 主入口模块
     *
     *@date 2019-04-29
     *@author chenyongzheng
     */
    export default {
        name: 'App'
    }
</script>

<!-- scss编译css -->
<style lang="scss">
    // 引入主样式表
    @import "styles/main";
</style>




// WEBPACK FOOTER //
// src/App.vue